import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { sectionName } from "@/lib/sections";

export const MostRead = ({ excludeSlug, className = "", id = "most-read" }) => {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/most-read", { params: { days: 7, limit: 6 } }).then((r) => setItems(r.data)).catch(() => {}); }, []);
  const list = items.filter((i) => i.slug !== excludeSlug).slice(0, 5);
  if (!list.length) return null;

  return (
    <section className={className} data-testid={id}>
      <h2 className="meta !text-[var(--ink)] pb-3 border-b border-[var(--ink)]">Most read this week</h2>
      <ol>
        {list.map((a, i) => (
          <li key={a.slug} className="flex gap-5 py-4 border-b border-[var(--rule)]" data-testid={`${id}-item-${a.slug}`}>
            <span className="font-display text-3xl font-bold text-[#C8C8C4] leading-none w-6 tabular-nums">{i + 1}</span>
            <div>
              <Link to={`/article/${a.slug}`} className="font-display text-lg font-semibold leading-snug headline-link">{a.headline}</Link>
              <p className="mt-1 meta !tracking-[0.12em]">{sectionName(a.section)}{a.interview ? " · In their words" : ""}</p>
            </div>
          </li>
        ))}
      </ol>
    </section>
  );
};
